import { RequestDefinition } from 'front-end-core/core/Api'

import {
  CURRENT_AWARENESS,
  CURRENT_AWARENESS_PREPAY,
  CURRENT_AWARENESS_HOMEPAGE,
  CURRENT_AWARENESS_HOMEPAGE_ARTICLE,
  CURRENT_AWARENESS_HOMEPAGE_ARTICLE_PREPAY,
  CURRENT_AWARENESS_SEARCH,
  CURRENT_AWARENESS_SEARCH_PREPAY,
  CURRENT_AWARENESS_ARTICLE,
  GUIDES,
  FEATURED_GUIDES,
  PUBLISHED_CA_KEY_PICKS
} from 'constants/requests'
import {
  URL_CURRENT_AWARENESS,
  URL_CURRENT_AWARENESS_PREPAY,
  URL_GUIDES,
  URL_FEATURED_GUIDES,
  URL_PUBLISHED_CA_KEY_PICKS,
  URL_CURRENT_AWARENESS_HOMEPAGE,
  URL_CURRENT_AWARENESS_HOMEPAGE_ARTICLE,
  URL_CURRENT_AWARENESS_HOMEPAGE_ARTICLE_PREPAY,
  URL_CURRENT_AWARENESS_SEARCH,
  URL_CURRENT_AWARENESS_SEARCH_PREPAY,
  URL_CURRENT_AWARENESS_ARTICLE
} from 'constants/urls'
import { toCurrentAwareness, toGuides, toContentFolders, toCurrentAwarenessSearchResults } from './transforms'
import { toPublishedCaKeyPicks } from 'requests/ca/transforms'

export const CurrentAwareness = new RequestDefinition({
  name: CURRENT_AWARENESS,
  url: URL_CURRENT_AWARENESS,
  transform: toCurrentAwareness
})

export const CurrentAwarenessPrepay = new RequestDefinition({
  name: CURRENT_AWARENESS_PREPAY,
  url: URL_CURRENT_AWARENESS_PREPAY,
  transform: toCurrentAwareness
})

export const CurrentAwarenessArticle = new RequestDefinition({
  name: CURRENT_AWARENESS_ARTICLE,
  url: URL_CURRENT_AWARENESS_ARTICLE,
  transform: toCurrentAwareness
})

export const CurrentAwarenessSearch = new RequestDefinition({
  name: CURRENT_AWARENESS_SEARCH,
  url: URL_CURRENT_AWARENESS_SEARCH,
  transform: toCurrentAwarenessSearchResults
})

export const CurrentAwarenessSearchPrepay = new RequestDefinition({
  name: CURRENT_AWARENESS_SEARCH_PREPAY,
  url: URL_CURRENT_AWARENESS_SEARCH_PREPAY,
  transform: toCurrentAwarenessSearchResults
})

export const Guides = new RequestDefinition({
  name: GUIDES,
  url: URL_GUIDES,
  transform: toContentFolders
})

export const FeaturedGuides = new RequestDefinition({
  name: FEATURED_GUIDES,
  url: URL_FEATURED_GUIDES,
  transform: toGuides
})

export const PublishedCaKeyPicks = new RequestDefinition({
  name: PUBLISHED_CA_KEY_PICKS,
  url: URL_PUBLISHED_CA_KEY_PICKS,
  transform: toPublishedCaKeyPicks
})

export const HomePageArticles = new RequestDefinition({
  name: CURRENT_AWARENESS_HOMEPAGE,
  url: URL_CURRENT_AWARENESS_HOMEPAGE,
  transform: toCurrentAwareness
})

export const HomePageArticleSingle = new RequestDefinition({
  name: CURRENT_AWARENESS_HOMEPAGE_ARTICLE,
  url: URL_CURRENT_AWARENESS_HOMEPAGE_ARTICLE,
  transform: toCurrentAwareness
})

export const HomePageArticleSinglePrepay = new RequestDefinition({
  name: CURRENT_AWARENESS_HOMEPAGE_ARTICLE_PREPAY,
  url: URL_CURRENT_AWARENESS_HOMEPAGE_ARTICLE_PREPAY,
  transform: toCurrentAwareness
})
